import React, { Component } from 'react';
import { loggerEventName, loggerEventOutcome, loggerEventTypes, userMessages } from '../../../helpers/messages';
import { logger } from '../../../services/logger/logger-service';
import { validateAlphanumeric, validateEmployeeID, validateSNEmail, validateUserFields } from '../../../shared/ValidateUser';
import { saveUserRoleMapping } from '../../../services/java/java-services';
import CreateMappedUser from './CreateMappedUser';

let startDate;
class CreateMappedUserContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showSuccessMsg: '',
            showEmailSuccessMsg: '',
            showErrorMsg: '',
            successMessage: '',
            pwdStrengthLabel: '',
            pwdStrengthProgress: '',
            pwdStrengthVarient: '',
            expMatch: {},
            cognitoUser: '',
            userSaveError: null,
            countries: null,
            userObj: {
                firstName: '',
                lastName: '',
                email: '',
                role: '',
                employeeID: '',
            },
            errors: {
                firstName: '',
                lastName: '',
                email: '',
                role: '',
                employeeID: '',
            }
        }
    }

    componentDidMount() {
        // initialize the start date on page load
        startDate = new Date();
        window.addEventListener('beforeunload', this.timeSpentLogger);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.timeSpentLogger);
        this.timeSpentLogger();
    }

    /**
     * @description function to handle application logs for time spent on the page
     * @param {*}
     * @memberof CreateMappedUserContainer
     */
    timeSpentLogger(key) {
        // calculate the time since we loaded this page
        const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
        const loggerObj = {
            "EventOutcome": loggerEventOutcome.success,
            "EventType": loggerEventTypes.read,
            "EventName": loggerEventName.mappedUserCreate,
            "Content": {
                "TimeSpent": timeSinceLoad
            }
        }
        logger(loggerObj);
    }

    /**
     * @description Function to handle input changes
     * @param  value Value of the input
     * @param  field Input field name
     * @memberof CreateMappedUserContainer
     */
    handleInputChange = (field, value) => {
        this.setState({ showSuccessMsg: '', showErrorMsg: '', userSaveError: null });
        var { errors } = this.state;
        var errorMessage = !value ? userMessages[field] : '';
        if ((field === 'firstName' || field === 'lastName') && value) {
            const surgeonNameCheck = validateAlphanumeric(value);
            errorMessage = surgeonNameCheck.error;
        }

        if (field === 'employeeID') {
            if (value) {
                const employeeID = validateEmployeeID(value);
                errorMessage = employeeID.error;
            } else {
                errorMessage = '';
            }            
        }

        this.setState(prevState => {
            return {
                [field]: value,
                userObj: {
                    ...prevState.userObj,
                    [field]: value
                },
                errors: {
                    ...errors,
                    [field]: errorMessage
                }
            }
        });
    }

    /**
    * @description Function to handle blur event in  form
    * @memberof CreateMappedUserContainer
    */
    handleBlur = (field, value) => {
        var { errors } = this.state;
        var errorMessage = !value ? userMessages[field] : '';
        if (field === 'email' && value) {
            const emailCheck = validateSNEmail(value);
            errorMessage = emailCheck.error;
        }
        this.setState(prevState => {
            return {
                [field]: value,
                userObj: {
                    ...prevState.userObj,
                    [field]: value
                },
                errors: {
                    ...errors,
                    [field]: errorMessage
                }
            }
        });
    }

    /** 
     * @description Function submit form by hitting enter key
     *  @param e Keypress event
     *  @memberof CreateMappedUserContainer
     */
    onEnterPress = (e) => {
        if (e.which === 13) {
            e.preventDefault();
            this.saveUser();
        }
    }

    /**
     * @description Function to validate fields at the time of submit
     * @returns Boolean value if there are any errors
     * @memberof CreateMappedUserContainer
     */
    validateFields = () => {
        const { userObj } = this.state;
        const userFields = ['firstName', 'lastName', 'email', 'role'];
        let { errorFlag, errors } = validateUserFields({ editObj: userObj, errors: this.state.errors }, userFields);
        if (!errorFlag && userObj.firstName) {
            let firstName = validateAlphanumeric(userObj.firstName);
            errorFlag = firstName.errorFlag;
            errors['firstName'] = firstName.error;
        }
        if (!errorFlag && userObj.lastName) {
            let lastName = validateAlphanumeric(userObj.lastName);
            errorFlag = lastName.errorFlag;
            errors['lastName'] = lastName.error;
        }
        if (!errorFlag && userObj.email) {
            let email = validateSNEmail(userObj.email);
            errorFlag = email.errorFlag;
            errors['email'] = email.error;
        }
        if (!errorFlag && userObj.employeeID) {
            let employeeID = validateEmployeeID(userObj.employeeID);
            errorFlag = employeeID.errorFlag;
            errors['employeeID'] = employeeID.error;
        }

        if (errorFlag) {
            this.setState(prevState => {
                return {
                    errors: {
                        ...prevState.errors,
                        ...errors
                    }
                }
            })
        }

        return errorFlag;
    }

    /**
     * @description function to validate and save user details
     * @param {*}
     * @memberof CreateMappedUserContainer
     */
    saveUser = () => {
        this.setState({ showSuccessMsg: '', showErrorMsg: '' });
        const formHasErrors = this.validateFields();
        if (!formHasErrors) {
            this.addUserInDB();
        }
    }

    /**
     * @description function to add user in db
     * @param {*}
     * @memberof CreateMappedUserContainer
     */
    addUserInDB = () => {
        const { userObj } = this.state;
        var params = {
            firstname: userObj.firstName,
            lastname: userObj.lastName,
            email: userObj.email,
            employeeId: userObj.employeeID,
            dapRole: userObj.role,
        }
        
        this.setState({ loading: true });
        saveUserRoleMapping(params, (err, res) => {
            if (err) {
                this.handleErrorWithLogs(err);
            } else {
                this.setState({
                    loading: false,
                    showSuccessMsg: userMessages.mappedUserCreated,
                    showErrorMsg: '',
                    showEmailSuccessMsg: userMessages.emailSent,
                    userSaveError: null
                });
                this.props.userAdded(userObj.email);
            }
        });
    }

    /**
     * @description function to handle errors and log them
     * @memberof CreateMappedUserContainer
     */
    handleErrorWithLogs = (err) => {
        const errMsg = err && err.message ? err.message : userMessages.saveError;
        const params = {
            outcome: loggerEventOutcome.failure,
            message: errMsg
        }
        this.applicationLogger(params);
        this.setState({ loading: false, showErrorMsg: errMsg, userSaveError: err });
    }

    /**
     * @description function to log user creation event
     * @memberof CreateMappedUserContainer
     */
    applicationLogger = (params) => {
        const loggerObj = {
            "EventOutcome": params.outcome,
            "EventType": loggerEventTypes.create,
            "EventName": loggerEventName.mappedUserCreate,
            "Content": {
                "Data": params.message
            }
        }
        logger(loggerObj);
    }

    render() {
        return (
            <CreateMappedUser
                loading={this.state.loading}
                userObj={this.state.userObj}
                userSaveError={this.state.userSaveError}
                handleInputChange={this.handleInputChange}
                handleBlur={this.handleBlur}
                onEnterPress={this.onEnterPress}
                showSuccessMsg={this.state.showSuccessMsg}
                showEmailSuccessMsg={this.state.showEmailSuccessMsg}
                showErrorMsg={this.state.showErrorMsg}
                formErrors={this.state.errors}
                saveUser={this.saveUser}
                handleCancel={this.props.handleCancel}
            />
        );
    }
}

export default CreateMappedUserContainer;
